export type ResultPresentationCoverageReason = 'observation_capacity' | 'entry_unverified'
export interface ResultPresentationLoss {
  readonly source_event_id: string
  readonly observedAtMs: number
  readonly monotonicMs: number
  readonly visibility: 'visible' | 'hidden' | 'unknown'
  readonly suppressed_observations: number
}

export function createPresentationLossReporter(options: {
  now(): Pick<ResultPresentationLoss, 'observedAtMs' | 'monotonicMs' | 'visibility'>
  id(): string
  emit(loss: ResultPresentationLoss): void
}) {
  let lastKey: string | undefined
  let lastTime = -Infinity
  let suppressed = 0
  return (key: string, force = false) => {
    const time = options.now()
    // New opportunities are reported immediately. Only repeated updates to the
    // same refused opportunity share the collector's five-second convention.
    if (!force && key === lastKey && time.monotonicMs - lastTime < 5_000) {
      suppressed = Math.min(Number.MAX_SAFE_INTEGER, suppressed + 1)
      return
    }
    lastKey = key
    lastTime = time.monotonicMs
    const loss: ResultPresentationLoss = {
      source_event_id: options.id(),
      observedAtMs: time.observedAtMs,
      monotonicMs: time.monotonicMs,
      visibility: time.visibility,
      suppressed_observations: suppressed,
    }
    suppressed = 0
    options.emit(loss)
  }
}
